import React from "react";
import { MusicHallRegisNumberGuestStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const MusicHallRegisNumberGuest = ({
  initialValues,
  isDisabledForm,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    expected_attendees: yup.string().required("required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  const { t } = useTranslation(["common", "form", "room"]);

  return (
    <MusicHallRegisNumberGuestStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="textfield_layout">
          <div className="textfield_text1">
            {t("Number of Guests (120 Seats provided in the hall)", {
              ns: "form",
            })}
          </div>
          <div className="textfield_text2">
            {t(
              "If you expect more than 120 guests, you must request to rent the 6th floor (see terms and conditions for details)",
              { ns: "form" },
            )}
          </div>

          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                theme_standard
                disabled={isDisabledForm}
                type="number"
                min="1"
                placeholder={t("Your answer (number only)", { ns: "form" })}
                errors={errors.expected_attendees?.message}
              />
            )}
            name="expected_attendees"
            defaultValue=""
          />
        </div>
        <div className="button_layout">
          <div className="button1">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={onBack}
            />
          </div>
          <div className="button2">
            <Buttons.BgStandard
              theme_white_purple={isDisabledForm}
              label={t("Next", { ns: "common" })}
              type="submit"
            />
          </div>
        </div>
      </form>
    </MusicHallRegisNumberGuestStyled>
  );
};

MusicHallRegisNumberGuest.propTypes = {};

export default MusicHallRegisNumberGuest;
